<template>
    <div>
        <card-header title="Support" icon="fa-life-ring"/>

        <card-toolbar>
            <button @click="openCard('support-ticket-new')"><i class="far fa-envelope-open-text"></i>New Ticket</button>

            <template v-slot:right>
                <button class="icon-only" @click="openCard('support-settings')"><i class="far fa-cog"></i></button>
            </template>
        </card-toolbar>

        <card-body toolbar>
            <card-list>
                <search-list-item @action="searchTickets"/>

                <separator-list-item/>

                <navigation-list-item title="All Support Tickets" icon="fa-mail-bulk"></navigation-list-item>

                <subheader-list-item title="Unread Tickets" icon="fa-envelope" badge="3"/>

                <support-ticket-list-item @action="openCard('support-message')"/>
                <support-ticket-list-item/>
                <support-ticket-list-item/>

                <subheader-list-item title="Assigned Tickets" icon="fa-hand-point-up" badge="2"/>
                <support-ticket-list-item/>

                <subheader-list-item title="On Hold Tickets" icon="fa-pause" badge="8"/>

                <support-ticket-list-item/>
                <support-ticket-list-item/>
                <support-ticket-list-item/>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "../../components/common/CardHeader";
    import CardBody from "../../components/common/CardBody";
    import CardList from "../../components/common/CardList";
    import CardToolbar from "../../components/common/CardToolbar";
    import SupportTicketListItem from "../../components/SupportTicketListItem";
    import SubheaderListItem from "../../components/common/SubheaderListItem";
    import SearchListItem from "../../components/common/SearchListItem";
    import NavigationListItem from "../../components/common/NavigationListItem";
    import SeparatorListItem from "../../components/common/SeparatorListItem";

    export default {
        components: {SeparatorListItem, NavigationListItem, CardHeader, CardBody, CardList, CardToolbar, SupportTicketListItem, SubheaderListItem, SearchListItem},
        props: ['child'],
        methods: {
            searchTickets: function (q) {
                this.openCard('ticket-search', {query: q});
            },
            selectTicket: function (ticket) {
                this.openCard('support-message', {ticketId: ticket.id});
            },
            setActive: function () {

            },
            openCard: function (card, props) {
                this.$emit('open', {card: card, props: props});
            }
        },
        data() {
            return {

            }
        },
        watch: {
            'child': function (val) {
                this.setActive();
            }
        },
        mounted: function () {
            this.setActive();
        }
    }
</script>

<style lang="scss" scoped>

</style>
